<template>
  <div class="app-container">
    <!-- <div class="detailsTitle">
      <h4><i class="fa fa-bookmark" aria-hidden="true"></i>客户维护</h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
   </div> -->
    <div>
     <el-tabs v-model="activeName" >
      <!-- <el-tab-pane label="客户角色"  name="one">
        <ownRole :basic-data="basicData" v-if="activeName=='one'"></ownRole>
      </el-tab-pane> -->
      <el-tab-pane label="客户角色"  name="one">
        <newRole :basic-data="basicData" v-if="activeName=='one'"></newRole>
      </el-tab-pane>
      <el-tab-pane label="客户组织" name="two">
        <heHuZuZhi :basic-data="basicData" v-if="activeName=='two'"></heHuZuZhi>
      </el-tab-pane>
      <el-tab-pane label="客户用户" name="three">
        <maintainUsers :basic-data="basicData" v-if="activeName=='three'" :isWH="true"></maintainUsers>
      </el-tab-pane>
    </el-tabs>
   </div>
 </div>
</template>

<script>
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
// import ownRole from '@/views/newCrm/components/ownRole.vue'
import newRole from '@/views/newCrm/components/newRole.vue'
import maintainUsers from '@/views/newCrm/components/maintainUsers.vue'
import heHuZuZhi from '@/views/newCrm/customerManage/heHuZuZhi.vue'
export default {
  components: {
    // ownRole,
    maintainUsers,
    newRole,
    heHuZuZhi
  },
  data () {
    let tenantCode = this.$route.query.tenantCode
    // let tenantName = this.$route.query.tenantName
    let useTenantCode = this.$route.query.code
    let menuOrBtnId = this.$route.query.menuOrBtnId
    return {
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      activeName: 'one',
      basicData: {
        tenantCode: tenantCode,
        useTenantCode: useTenantCode,
        menuOrBtnId: menuOrBtnId

      }

    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>

<style scoped lang='less'>
.detailsTitle{
  border:none;
  margin: 0;
  h4{
    border: none;
  }
  .fa{
    margin-right: 6px;
    color: #0c46a2;
    font-size: 20px;
  }
}
</style>
